<div class="status__content">
	<span *ngIf="cellValue !== null">{{ cellValue.firstName + ' ' + cellValue.lastName}}</span>
</div>
